import React, { useEffect, useState } from "react";
import style from "./BookedCreditNote.module.css";
import HeadingBar from "./HeadingBar";
import MenuBar from "./MenuBar";
import MainSeachBar from "./MainSeachBar";
import axios from "axios";
import DateRangePicker from "./DateRangePicker";
import { toast } from "react-toastify";
import pdfIcon from "./assets/pdf.png";
import moment from "moment";
import { API_BASE_URL } from "./config.js";

const formatDateForAPI = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}${String(d.getDate()).padStart(2, "0")}`;
};
const BookedCreditNote = () => {
  const [selectedValue, setSelectedValue] = useState("O");
  const vendorDataRaw = sessionStorage.getItem("vendordata");
  const vendorInfo = vendorDataRaw ? JSON.parse(vendorDataRaw) : null;
  const vendorCode = vendorInfo?.CardCode || "";
  const [selectedLocation, setSelectedLocation] = useState("");
  const [locations, setLocations] = useState([]);
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const [bookedcreditnoteData, setBookedCreditNoteData] = useState([]);
  const [fromDate, setFromDate] = useState(
    firstDayOfMonth.toISOString().split("T")[0]
  );
  const [toDate, setToDate] = useState(
    lastDayOfMonth.toISOString().split("T")[0]
  );

  const fetchBookedCreditNoteData = async (from, to, status, location) => {
    if (!vendorCode) return;
    try {
      const res = await axios.get(
        `${API_BASE_URL}/BookedCreditNotes?VendorCode=${vendorCode}&FromDt=${formatDateForAPI(
          from
        )}&ToDt=${formatDateForAPI(to)}&Status=${status}&Location=${location}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setBookedCreditNoteData(res.data);
    } catch (error) {
      console.error("Error fetching PO data:", error);
    }
  };

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
    fetchBookedCreditNoteData(start, end, selectedValue, selectedLocation);
  };
  const fetchLocations = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/location`, {
        headers: { "Content-Type": "application/json" },
      });

      if (Array.isArray(res.data)) {
        setLocations(res.data);
      } else {
        console.warn("Unexpected location response:", res.data);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      toast.error("Failed to fetch locations.");
    }
  };
  useEffect(() => {
    fetchLocations();

    const start = moment().startOf("quarter").format("YYYY-MM-DD");
    const end = moment().endOf("quarter").format("YYYY-MM-DD");

    setFromDate(start);
    setToDate(end);

    fetchBookedCreditNoteData(
      fromDate,
      toDate,
      selectedValue,
      selectedLocation
    );
  }, [vendorCode]);

  const handleSearch = () => {
    fetchBookedCreditNoteData(
      fromDate,
      toDate,
      selectedValue,
      selectedLocation
    );
  };
  return (
    <div className={style.BookedInvoiceDetails}>
      {/* <div className={style.SerchBarContainer}>
        <MainSeachBar />
      </div> */}
      {/* <div className={style.HeadingBarContainer}>
                <HeadingBar />
            </div> */}
      <div className={style.BookedInvoiceDetailsContainer}>
        {/* <div className={style.MenuBarContainer}>
          <MenuBar />
        </div> */}
        <div className={style.MainBookedInvoiceDetailsContainer}>
          {/* <div className={style.MenuNameDetails}>Booked Debit Note</div> */}
          <div className={style.filterArea}>
            <div className={style.pofilter}>
              <div>Status</div>
              <select
                value={selectedValue}
                onChange={(e) => {
                  const newStatus = e.target.value;
                  setSelectedValue(newStatus);

                  fetchBookedCreditNoteData(
                    fromDate,
                    toDate,
                    newStatus,
                    selectedLocation
                  );
                }}
              >
                <option value="O">Open</option>
                <option value="C">Closed</option>
              </select>

              {/* 🔹 Location Dropdown */}
              <div>Location</div>
              <select
                value={selectedLocation}
                onChange={(e) => {
                  const newLoc = e.target.value;
                  setSelectedLocation(newLoc);
                  fetchBookedCreditNoteData(
                    fromDate,
                    toDate,
                    selectedValue,
                    newLoc
                  );
                }}
              >
                <option value="">All</option>
                {locations.map((loc, i) => (
                  <option key={loc.Code} value={loc.Code}>
                    {loc.Location}
                  </option>
                ))}
              </select>
            </div>
            <div className={style.datearea}>
              <DateRangePicker
                className={style.daterangepicker}
                onDateChange={handleDateChange}
                startDate={fromDate}
                endDate={toDate}
              />
              <button onClick={handleSearch}>Search</button>
            </div>
          </div>
          <div className={style.MainArea}>
            <div className={style.BookedInvoicetable}>
              <table>
                <thead>
                  <tr>
                    <td>Customer Booking #</td>
                    <td>Bokking Date</td>
                    <td>Vendor Invoice #</td>
                    <td>Vendor Invoice Date</td>
                    <td>Taxable Amount</td>
                    <td>Tax Amount</td>
                    <td>Total Amount</td>
                    <td>Location</td>
                  </tr>
                </thead>
                <tbody>
                  {bookedcreditnoteData.length > 0 ? (
                    bookedcreditnoteData.map((item, index) => (
                      <tr key={index}>
                        <td>{item.StarDocNum}</td>
                        <td>{item.StarDocDate}</td>
                        <td>{item.VendorDocNo}</td>
                        <td>{item.VendorDocDate || "-"}</td>
                        <td className="text-end amount-cell">
                          {item.DocCur}{" "}
                          {Number(item.TaxableAmt).toLocaleString("en-IN")}
                        </td>
                        <td className="text-end amount-cell">
                          {item.DocCur}{" "}
                          {Number(item.TaxAmt).toLocaleString("en-IN")}
                        </td>
                        <td className="text-end amount-cell">
                          {item.DocCur}{" "}
                          {Number(item.DocTotal).toLocaleString("en-IN")}
                        </td>
                        <td>{item.Location || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="12"
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          color: "#999",
                        }}
                      >
                        No Booked Credit Note Found. Please select a Date range.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookedCreditNote;
